import immutable from 'immutable'

import * as helpers from './helpers'
import { KILL_STATE } from '../constants/actions'

const INITIAL_STATE = immutable.fromJS([])

const displayReducer = (state = INITIAL_STATE, action) => {
    let objectIndex = -1
    // let newState = state
    switch (action.type) {
    case 'SET_DISPLAY_STATE':
        objectIndex = helpers.getObjectIndex(state, action.data.id, 'id')
        if (objectIndex === -1) {
            return helpers.addObject(state, action.data)
        }
        return helpers.updateObject(state, action.data, objectIndex)
    case 'CLEAR_DISPLAY_STATE':
        return state.filter(entry => {
            return action.data.id !== entry.get('id')
        })
    case KILL_STATE:
        return INITIAL_STATE
    default:
        return state
    }
}

export default displayReducer
